function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 5,
  y: 5,
  width: 56,
  height: 56,
  rx: 1,
  fill: "#F8B30B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.1359 14.4836C32.5216 13.8213 33.4784 13.8213 33.8641 14.4836L39.2439 23.72C39.3852 23.9626 39.6219 24.1347 39.8963 24.1941L50.3431 26.4563C51.0922 26.6185 51.3878 27.5284 50.8772 28.0999L43.7552 36.0706C43.5682 36.2799 43.4777 36.5583 43.506 36.8376L44.5828 47.4722C44.66 48.2347 43.8859 48.7971 43.1846 48.488L33.4032 44.1777C33.1463 44.0645 32.8537 44.0645 32.5968 44.1777L22.8154 48.488C22.1141 48.7971 21.34 48.2347 21.4172 47.4722L22.494 36.8376C22.5223 36.5583 22.4318 36.2799 22.2448 36.0706L15.1228 28.0999C14.6122 27.5284 14.9078 26.6185 15.6569 26.4563L26.1037 24.1941C26.3781 24.1347 26.6148 23.9626 26.7562 23.72L32.1359 14.4836Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.562 26.4V39H32.646V28.74H30.126V26.4H35.562Z",
  fill: "#F8B30B"
});

var SvgAdminFeatured = function SvgAdminFeatured(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdminFeatured, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AdminFeatured.6cc3081c.svg";
export { ForwardRef as ReactComponent };